export class NewPhoneNumbersRange {
  id: number;
  connectionType: string;
  totalCount: number;
  offeredCount: string;
  costMonthly: number;
  costMonthlyEdit: boolean;
  costUnique: number;
  costUniqueEdit: boolean;
  cat: string;
  catMonthly: number;
  catUnique: number;

  constructor() {
    this.connectionType = 'Swiss phone number';
    this.totalCount = 1;
    this.offeredCount = '2-5';
    this.costMonthly =  500;
    this.costMonthlyEdit = false;
    this.costUnique = 0;
    this.costUniqueEdit = false;
    this.cat = 'No';
    this.catMonthly = 0;
    this.catUnique = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/newPhoneNumbersRange.ts